import { LoadingStatusType } from "@/enums/enums";
import { AllocationItemModel } from "@/model/allocation/allocationItemModel";
import { AllocationModel } from "@/model/allocation/allocationModel";
import { ConvertToAllocationItemList, ConvertToAllocationList } from "@/service/allocation/allocationFacade";
import API from "@/service/Index";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class Allocation extends VuexModule {
  public allocationList: Array<AllocationModel> | null = null;
  public allocationLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public allocationItemList: any = null;
  public allocationItemLoadingStatus: LoadingStatusType = LoadingStatusType.None;

  get getAllocationLoadingStatus(): LoadingStatusType {
    return this.allocationLoadingStatus;
  }
  get getAllocationList(): Array<AllocationModel> | null {
    return this.allocationList;
  }
  get getAllocationItemLoadingStatus(): LoadingStatusType {
    return this.allocationItemLoadingStatus;
  }
  get getAllocationItemList(): any {
    return this.allocationItemList;
  }

  @Mutation
  public MutationSetAllocationLoadingStatus(status: LoadingStatusType) {
    this.allocationLoadingStatus = status;
  }
  @Mutation
  public MutationSetAllocationItemLoadingStatus(status: LoadingStatusType) {
    this.allocationItemLoadingStatus = status;
  }

  @Mutation
  public MutationAllocationList(allocationList: any) {
    this.allocationList = [];
    this.allocationList = allocationList;
  }

  @Mutation
  public MutationAllocationItemList(input: any) {
    if (this.allocationItemList && this.allocationItemList.length > 0) {
      const index = this.allocationItemList.findIndex((x: any) => x.allocationId === input.allocationId);
      if (index > -1) {
        this.allocationItemList[index].allocationItemList = input.allocationItemList;
      } else {
        this.allocationItemList.push({
          allocationId: input.allocationId,
          allocationItemList: input.allocationItemList,
        });
      }
    } else {
      this.allocationItemList = [];
      this.allocationItemList.push({ allocationId: input.allocationId, allocationItemList: input.allocationItemList });
    }
  }

  @Action
  public DoGetAllocationList() {
    if (this.allocationLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetAllocationLoadingStatus", LoadingStatusType.Loading);
      API.AllocationService.DoGetAllocationList().then((res) => {
        const allocationList: Array<AllocationModel> = ConvertToAllocationList(res.data.allocationList);
        this.context.commit("MutationAllocationList", allocationList);
        this.context.commit("MutationSetAllocationLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoGetAllocationItemList(allocationId: number) {
    if (this.allocationItemLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetAllocationItemLoadingStatus", LoadingStatusType.Loading);

      API.AllocationService.DoGetAllocationItemList(allocationId).then((res) => {
        const allocationItemList: Array<AllocationItemModel> = ConvertToAllocationItemList(res.data.allocationItemList);
        this.context.commit("MutationAllocationItemList", {
          allocationItemList: allocationItemList,
          allocationId: allocationId,
        });
        this.context.commit("MutationSetAllocationItemLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
}
